import * as types from './types';
import AuthService from 'services/Auth';

const initialState = {
  // Stay in loading until auth user resolves when a token is already present,
  // so we don't briefly run non-admin bootstrap (restaurants?per=10000).
  getInProcess: Boolean(AuthService.getToken()),
  authInitialized: false,
  updateInProcess: true,
  data: {},
  isSuperAdmin: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordInProcess: true,
      };
    case types.USER_GET_AUTH_USER:
      return {
        ...state,
        // Only block the app shell during the initial auth bootstrap.
        getInProcess:
          !state.authInitialized && Object.keys(state.data || {}).length === 0,
      };
    case types.USER_GET_AUTH_USER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isSuperAdmin: action.payload?.role === 'root',
        getInProcess: false,
        authInitialized: true,
      };
      case types.USER_GET_AUTH_USER_FAILURE:
      return {
        ...state,
        isSuperAdmin: false,
        getInProcess: false,
        authInitialized: true,
      };
    case types.SET_USER_ROLE:
      return {
        ...state,
        isSuperAdmin: action.payload?.role === 'root',
      };
    case types.USER_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordErrors: null,
        resetPasswordInProcess: false,
      };
    case types.USER_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordErrors: action.payload,
        resetPasswordInProcess: false,
      };
    case types.USER_SEND_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        sendResetPasswordInProcess: true,
      };
    case types.USER_SEND_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        sendResetPasswordInProcess: false,
      };
    case types.USER_SEND_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        sendResetPasswordInProcess: false,
        sendResetPasswordErrors: action.payload,
      };
    case types.USER_LOGIN_REQUEST:
      return {
        ...state,
        signInInProcess: true,
      };
    case types.USER_LOGIN_FAILURE:
      return {
        ...state,
        signInInProcess: false,
        signInErrors: action.payload,
      };
    case types.USER_LOGIN_SUCCESS:
      return {
        ...state,
        signInInProcess: false,
        data: {
          ...state.data,
          ...action.payload
        },
        isSuperAdmin: action.payload?.role === 'root',
        authInitialized: action.payload?.role === 'root',
      };
    default:
      return state;
  }
};

export default userReducer;
